import { useState } from "react";
import { useTranslationApp } from "../../../../../lib/i18next";
import { Controller, useController } from "react-hook-form";
import { getReactHookFormNestedError } from "../../../../../utils/errors";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import Button from "../../../../Buttons/Button";
import {
  BUTTON_EDIT,
  BUTTON_REMOVE,
  BUTTON_SELECT_INSTANT_EXPERIENCE,
} from "../../../../../i18n/keysTranslations";
import { META } from "../../../../../utils/constants";
import ModalInstantExperienceCreate from "../../../../Meta/ModalInstantExperienceCreate";

const InstantExperienceContainer = ({
  label,
  name,
  integrationID,
  pageID,
  control,
  errors,
  disabled,
  adAccountID,
  productSetID,
  destinationType,
  appID,
  disabledProductConfiguration,
  onCallbackProductInformation = () => {},
  language,
}) => {
  const [modalInstantExperienceList, setModalInstantExperienceList] =
    useState(false);
  const {
    field: { value, onChange },
  } = useController({
    control,
    name,
    defaultValue: "",
  });

  const error = getReactHookFormNestedError(errors, name);
  const { t } = useTranslationApp();

  const isEmptyInstantExperience = _.isEmpty(value);

  const onToggleModalInstantExperienceList = () => {
    if (disabled) return;
    setModalInstantExperienceList((prev) => !prev);
  };

  const onEditInstantExperience = () => {
    if (disabled) return;
    setModalInstantExperienceList((prev) => !prev);
  };

  const onDeleteInstantExperience = () => {
    onChange(null);
  };

  const onCallbackSave = ({ instantExperience, productSetID, catalogID }) => {
    onChange(instantExperience);
    onCallbackProductInformation({ productSetID, catalogID });
    onToggleModalInstantExperienceList();
  };

  return (
    <Controller
      name={name}
      control={control}
      render={() => (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: error?.message ? "error.main" : "success.main",
              flexShrink: 0,
            }}
          />
          <Typography variant="body1">{label}</Typography>
          <Typography variant="body1">-</Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
            }}
          >
            {!isEmptyInstantExperience && (
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap={2}
              >
                <Typography variant="body2">{value.name}</Typography>
                {!disabled && (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                    }}
                  >
                    <Button
                      color="secondary"
                      type="button"
                      onClick={onEditInstantExperience}
                    >
                      {t(BUTTON_EDIT)}
                    </Button>
                    <Button
                      color="secondary"
                      type="button"
                      onClick={onDeleteInstantExperience}
                    >
                      {t(BUTTON_REMOVE)}
                    </Button>
                  </Box>
                )}
              </Box>
            )}
            {isEmptyInstantExperience && (
              <Button
                color="secondary"
                type="button"
                onClick={onToggleModalInstantExperienceList}
                disabled={disabled}
              >
                {t(BUTTON_SELECT_INSTANT_EXPERIENCE)}
              </Button>
            )}
          </Box>
          {error?.message && (
            <Typography variant="body2" color="error">
              {error.message}
            </Typography>
          )}
          {modalInstantExperienceList && (
            <ModalInstantExperienceCreate
              modalOpen={modalInstantExperienceList}
              onCloseModal={onToggleModalInstantExperienceList}
              platform={META}
              integrationID={integrationID}
              adAccountID={adAccountID}
              pageID={pageID}
              productSetID={productSetID}
              appID={appID}
              callToAction={value?.callToAction}
              destinationUrl={value?.destinationUrl}
              mediaUrl={value?.thumbnail}
              destinationType={destinationType}
              onCallbackSave={onCallbackSave}
              disabledProductConfiguration={disabledProductConfiguration}
              language={language}
            />
          )}
        </Box>
      )}
    />
  );
};

export default InstantExperienceContainer;
